import type { Sight } from '../types';
import type { Locale } from '../shared/locale';
import { API_HOST } from '../config/apiConfig';
import { mapSight } from './poiClient';
import { buildJsonHeaders } from './assistantAuth';

const CONFIG_API_PATH = '/api/config';

export type AppClientConfig = {
  pois: Sight[];
};

type RawAppClientConfig = {
  pois: Sight[];
};

export const requestAppConfig = async (locale: Locale): Promise<AppClientConfig> => {
  const url = `${API_HOST}${CONFIG_API_PATH}?locale=${encodeURIComponent(locale)}&responseFormat=markdown`;

  const response = await fetch(url, {
    method: 'GET',
    headers: buildJsonHeaders(),
  });

  if (!response.ok) {
    let message = 'Failed to load app config.';
    try {
      const errorBody = (await response.json()) as { message?: string };
      if (typeof errorBody?.message === 'string') {
        message = errorBody.message;
      }
    } catch {
      // Ignore JSON parsing errors – fall back to generic text
    }
    throw new Error(message);
  }

  const data = (await response.json()) as RawAppClientConfig;

  return {
    pois: Array.isArray(data.pois) ? data.pois.map((sight) => mapSight(sight, locale)) : [],
  };
};
